/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { PageContentMessage } from "../../../messages";
import profileCardConfig from "../../../config/profileCard.config.json";

const MODULE_NAME =
  "services.PortfolioUnderReviewPageService.machines.GetPageContent.state.formatProfileCard";
const log = LoggerModule?.getInstance();

export const formatProfileCard = async (context: any, event: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const msg = context?.input as PageContentMessage;
      if (msg?.profileCard) {
        if (msg?.node?.name) {
          msg.profileCard.fullName = msg.node?.name;
        }
        if (msg?.node?.description) {
          msg.profileCard.description = msg.node?.description;
        }
        if (msg?.node?.logo) {
          msg.profileCard.profilePicture = msg.node?.logo;
        }
        if (msg?.node?.bannerImage) {
          msg.profileCard.profileCover = msg.node?.bannerImage;
        } else {
          msg.profileCard.profileCover = profileCardConfig?.profileCover;
        }
        if (msg?.node?.socialLinks) {
          msg.profileCard.socialLinks = msg.node?.socialLinks;
        }
      }
      return resolve(true);
    } catch (err: any) {
      log?.error(MODULE_NAME, "error in formatProfileCard", err);
      return reject(err?.message);
    }
  });
};
